@if (data) {
<div class="font-poppins text-gray-800">
  <h3 class="text-xl font-bold mb-1">Schedule of Activities</h3>
  <div class="overflow-x-auto">
    <table class="table w-full table-compact">
      <thead>
        <tr class="border border-gray-300">
          <th class="font-semibold text-gray-800 py-2 whitespace-nowrap">Visit Name</th>
          <th class="font-semibold text-gray-800 py-2">Activity Name</th>
        </tr>
      </thead>
      <tbody>
        @for(mapping of data.all_mappings; track mapping) {
        <tr class="border border-gray-200">
          <td class="py-1 whitespace-nowrap">{{ mapping.visit_name }}</td>
          <td class="py-1">{{ mapping.activity_name }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
}